// Arrangement grid — a section x track table of on/off toggles for songs
// that have been split into sections (see makeSections in starterTape.js).
// Switching a track off in a section is how the arrangement thins out and
// fills back in as the loop plays through.

import React from "react";
import { cn } from "../../lib/utils";
import { INSTRUMENTS } from "../../lib/starterTape";
import { LANE_STYLES } from "./LaneList";

export default function ArrangementGrid({ song, onToggle }) {
  if (!song.sections) return null;

  return (
    <div className="mb-4 rounded-xl border border-zinc-800 bg-zinc-900/60 p-3">
      <p className="text-sm font-semibold text-zinc-100">Sections</p>
      <p className="mb-2 text-xs text-zinc-500">
        Switch lanes on and off in each section. Thin to thick and back is a
        journey.
      </p>
      <div className="overflow-x-auto">
        <table className="min-w-[36rem] border-collapse">
          <thead>
            <tr>
              <th className="p-1 text-left text-xs uppercase tracking-wide text-zinc-500">
                lane
              </th>
              {song.sections.map((section) => (
                <th
                  key={section.id}
                  className="p-1 text-center text-xs uppercase tracking-wide text-zinc-500"
                >
                  <div>{section.name}</div>
                  <div className="text-[10px] font-normal text-zinc-600">
                    bars {section.startBar + 1}–{section.startBar + section.bars}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {song.tracks.map((track) => {
              const inst = INSTRUMENTS[track.instrument];
              const style = LANE_STYLES[track.instrument];
              return (
                <tr key={track.id}>
                  <td className="p-1">
                    <span className="flex items-center gap-2 text-sm text-zinc-200">
                      <span className={cn("h-2 w-2 rounded-full", style.dot)} />
                      {inst.name}
                    </span>
                  </td>
                  {song.sections.map((section) => {
                    const on = !section.off.includes(track.id);
                    return (
                      <td key={section.id} className="p-1 text-center">
                        <button
                          type="button"
                          onClick={() => onToggle(section.id, track.id, !on)}
                          aria-pressed={on}
                          aria-label={`${section.name}: ${inst.name} ${
                            on ? "on" : "off"
                          }`}
                          className={cn(
                            "w-14 rounded-md border px-2 py-1 text-xs font-medium",
                            on
                              ? cn("border-transparent text-zinc-900", style.dot)
                              : "border-zinc-700 text-zinc-500"
                          )}
                        >
                          {on ? "on" : "off"}
                        </button>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
